var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverdue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 8.02979V11.9298L12.73 13.9448L13.25 13.1648L10.325 11.4098V8.02979H9.35ZM15.2 11.2798V15.1798H16.5V11.2798H15.2ZM15.2 16.4798V17.7798H16.5V16.4798H15.2ZM13.9 16.4798C12.795 17.3248 11.495 17.7798 10 17.7798C6.425 17.7798 3.5 14.8548 3.5 11.2798C3.5 7.70479 6.425 4.77979 10 4.77979C13.12 4.77979 15.785 6.98979 16.37 9.97978H15.005C14.42 7.76978 12.405 6.07979 10 6.07979C7.14 6.07979 4.8 8.41979 4.8 11.2798C4.8 14.1398 7.14 16.4798 10 16.4798C11.56 16.4798 12.925 15.7648 13.9 14.7248V16.4798Z",
    fill: "#702E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.971351acc8dae27a0d1b81ac36631e68.svg";
export { ForwardRef as ReactComponent };